/**
 * Herstellers data per maatschappij.
 * Bevat contactgegevens voor glas, reconditionering, brand, auto, cyber en rechtsbijstand.
 */

export interface Contact {
  naam: string;
  telefoon?: string;
  website?: string;
  email?: string;
  opmerking?: string;
}

export interface Categorie {
  titel: string;
  contacten: Contact[];
}

export interface Maatschappij {
  naam: string;
  logo: string;
  categorieen: Categorie[];
}

// Herbruikbare contacten
const glasherstel: Contact = {
  naam: 'Service Glasherstel',
  telefoon: '0229-276554',
  website: 'www.serviceglasherstel.nl',
  email: 'info@serviceglasherstel.nl',
};

const uniglas: Contact = {
  naam: 'Uniglas',
  telefoon: '050-3695252',
  website: 'www.uniglas.nl',
  email: 'meldkamer@uniglas.nl',
};

const dolmans: Contact = {
  naam: 'Dolmans',
  telefoon: '030-6888520',
  website: 'www.dolmans.nl',
  email: 'servicecenter@dolmans.com',
};

const polygon: Contact = {
  naam: 'Polygon',
  telefoon: '0172-421600',
  website: 'www.polygongroup.com/nl-NL',
  email: 'nederland@polygon-group.com',
};

const salvage: Contact = {
  naam: 'Salvage',
  opmerking: 'wordt ingeschakeld door de brandweer',
};

const cunningham: Contact = {
  naam: 'Cunningham Lindsey',
  telefoon: '088-2866464',
  website: 'www.cunninghamlindsey.com/nl',
  email: 'info@cl-nl.com',
};

const ced: Contact = {
  naam: 'CED',
  telefoon: '010-2843600',
  opmerking: '(expert)',
};

const glasgarant: Contact = {
  naam: 'Glasgarant',
  telefoon: '085-902 08 76',
  website: 'www.glasgarant.nl',
  email: 'info@glasgarant.nl',
};

const schadegarant: Contact = {
  naam: 'Schadegarant',
  telefoon: '085-902 08 77',
  website: 'www.schadegarant.nl',
  email: 'info@schadegarant.nl',
};

const das: Contact = {
  naam: 'DAS',
  telefoon: '020-6518888',
  website: 'www.das.nl',
};

const clarixy: Contact = {
  naam: 'Clarixy',
  telefoon: '0800-0207207',
  website: 'https://clarixy.nl/',
  email: 'klantenservice@clarixy.nl',
};

export const maatschappijen: Maatschappij[] = [
  {
    naam: 'ASR',
    logo: 'VA059',
    categorieen: [
      { titel: 'Glas', contacten: [glasherstel, uniglas] },
      { titel: 'Reconditionering / lekdetectie', contacten: [dolmans, polygon] },
      { titel: 'Brand', contacten: [cunningham, salvage] },
      { titel: 'Auto', contacten: [glasgarant, schadegarant] },
      { titel: 'Rechtsbijstand', contacten: [das] },
    ],
  },
  {
    naam: 'AIG',
    logo: 'aig',
    categorieen: [
      {
        titel: 'Cyber',
        contacten: [{ naam: 'First response hotline', telefoon: '+44-1273730992' }],
      },
    ],
  },
  {
    naam: 'ARAG',
    logo: 'arag',
    categorieen: [
      {
        titel: 'Rechtsbijstand',
        contacten: [
          {
            naam: 'Algemeen',
            telefoon: '033-4342342',
            website: 'www.arag.nl',
          },
          { naam: 'Spoed?', telefoon: '033-4342498' },
        ],
      },
    ],
  },
  {
    naam: 'Chubb',
    logo: 'chubb',
    categorieen: [
      {
        titel: 'Cyber',
        contacten: [{ naam: 'Algemeen', telefoon: '010-2893545' }],
      },
    ],
  },
  {
    naam: 'DAS',
    logo: 'das',
    categorieen: [{ titel: 'Rechtsbijstand', contacten: [das] }],
  },
  {
    naam: 'Hiscox',
    logo: 'hiscox',
    categorieen: [
      {
        titel: 'Cyber',
        contacten: [{ naam: 'Algemeen', telefoon: '020-5170700' }],
      },
    ],
  },
  {
    naam: 'Midglas',
    logo: 'midglas2',
    categorieen: [
      {
        titel: 'Glas',
        contacten: [clarixy],
      },
    ],
  },
  {
    naam: 'Nationale-Nederlanden',
    logo: 'nationalenederlanden',
    categorieen: [
      { titel: 'Glas', contacten: [glasherstel] },
      { titel: 'Reconditionering / lekdetectie', contacten: [dolmans, polygon] },
      { titel: 'Brand', contacten: [ced, dolmans, salvage] },
      { titel: 'Auto', contacten: [glasgarant, schadegarant] },
      { titel: 'Rechtsbijstand', contacten: [das] },
    ],
  },
];
